import { Box, Flex, Icon, Text, useColorModeValue } from '@chakra-ui/react';
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  InformationCircleIcon,
  ExclamationIcon
} from '@heroicons/react/solid';

type Props = {
  type?: 'Danger' | 'Info' | 'Success' | 'Warning';
  children: any;
};

export function Callout({ type, children }: Props) {
  const secondaryBlue = `primary.500`;

  const iconSwitch = () => {
    switch (type?.toLowerCase()) {
      case 'danger':
        return { icon: ExclamationCircleIcon, color: 'red.500' };
      case 'warning':
        return { icon: ExclamationIcon, color: 'yellow.500' };
      case 'success':
        return { icon: CheckCircleIcon, color: 'green.500' };
      case 'info':
        return { icon: InformationCircleIcon, color: secondaryBlue };
      default:
        return { icon: InformationCircleIcon, color: secondaryBlue };
    }
  };

  const borderSwitch = () => {
    switch (type?.toLowerCase()) {
      case 'danger':
        return { color: 'red.500' };
      case 'warning':
        return { color: 'yellow.500' };
      case 'success':
        return { color: 'green.500' };
      case 'info':
        return { color: secondaryBlue };
      default:
        return { color: secondaryBlue };
    }
  };

  const { icon, color: iconColor } = iconSwitch();
  const { color: borderColor } = borderSwitch();

  return (
    <Flex
      justify="center"
      align={'center'}
      px={6}
      py={4}
      my={6}
      bg={useColorModeValue('gray.100', '#282C34')}
      gap={4}
      rounded="md"
      borderLeft="solid 4px"
      borderColor={borderColor}
    >
      {/* if the callout has multiple paragraphs, the icon will top-align, otherwise, it will center-align */}
      <Icon
        as={icon}
        color={iconColor}
        boxSize={5}
        pos="relative"
        style={
          children.length > 1
            ? { alignSelf: 'flex-start', marginTop: '3px' }
            : {}
        }
      />
      <Box w="full">
        <Text
          as="div"
          display="flex"
          flexDirection="column"
          gap="4"
          sx={{
            '& p': {
              lineHeight: 'base',
              m: 0
            },

            '& a': {
              color: 'var(--tertiaryBlue)'
            }
          }}
        >
          {children}
        </Text>
      </Box>
    </Flex>
  );
}
